import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { useEffect } from 'react';

import { RecordingModel } from 'features/recordings/RecordingModel';
import { recordingSelector } from 'features/recordings/recordingsSelectors';
import { fetchRecording } from './recordingsSlice';
import { useSubdomain } from 'hooks/useSubdomain';

export const useRecording = (id?: string): RecordingModel | null => {
  const recording = useSelector((state: RootState) =>
    recordingSelector(state, id)
  );

  return recording;
};

export const useCurrentRecording = (): RecordingModel | null => {
  const currentRecordingId = useSelector(
    (state: RootState) => state.recordings.currentRecordingId
  );
  return useSelector((state: RootState) =>
    recordingSelector(state, currentRecordingId)
  );
};

export const useFetchRecording = (id: string | null | undefined): null => {
  const dispatch = useDispatch();
  const channelSubdomain = useSubdomain();

  useEffect(() => {
    if (id && channelSubdomain) {
      dispatch(fetchRecording(channelSubdomain, id));
    }
  }, [id, channelSubdomain, dispatch]);

  return null;
};
